module.exports = __webpack_public_path__ + "img/paragraph.9f317088.svg";